import styled from 'styled-components';

import { getWidgetSpacing } from '../utils';

export const DoubleButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.5rem 0 1rem;
  background-color: ${Styles.color.highlight};
  margin: 0 0 ${getWidgetSpacing.vertical()};
  & button {
    margin: 0 0.5rem;
    height: 2.75rem;
    padding: 0;
    width: 9.375rem;
  }
  ${Styles.desktop`
    margin: 0 0 ${getWidgetSpacing.vertical('desktop')};
    border-radius: 0 0 ${Styles.borderRadius} ${Styles.borderRadius}
  `}
`;
